import api from "./axiosInterceptor.js";

export default async function DeleteData(url, idsToDelete = []) { // Add an 'idsToDelete' parameter, defaulting to an empty array
    try {
        const response = await api.delete(`api/${url}`, { data: { ids: idsToDelete } }); // Send IDs in the request body
        if (response.status === 200) {
            return { success: true, error: false, load: false };
        } else {
            return { success: false, error: true, load: false, statusCode: response.status };
        }
    } catch (err) {
        console.error("Error during DELETE request:", err);
        return { success: false, error: err, load: false };
    }
}